import { render, staticRenderFns } from "./2024.vue?vue&type=template&id=5bd2201a&scoped=true&"
import script from "./2024.vue?vue&type=script&lang=js&"
export * from "./2024.vue?vue&type=script&lang=js&"
import style0 from "./2024.vue?vue&type=style&index=0&id=5bd2201a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd2201a",
  null
  
)

export default component.exports